import { animated } from '@react-spring/web';
import styled from 'styled-components';
import { palette } from 'styled-tools';

import { buttonNormalize } from '../../utils/buttonNormalize';
import { fontSize, FontSizes, fontWeight, FontWeights } from '../../utils/typography';

export const DivWrapper = styled(animated.div)<{ $isSuccess?: boolean; $errorBackgroundColor?: string }>`
	background: ${({ $isSuccess, $errorBackgroundColor }) =>
		$isSuccess ? palette('noticeBgSuccess') : $errorBackgroundColor || palette('noticeBgError')};
	border-radius: 8px;
	color: ${({ $isSuccess, $errorBackgroundColor }) =>
		$isSuccess ? palette('noticeTextSuccess') : $errorBackgroundColor ? 'white' : palette('noticeTextError')};
	${fontWeight(FontWeights.Medium)};
	${fontSize(FontSizes.sm)};
	line-height: 1.5;
	margin-bottom: 24px;
	padding: 10px;
	text-align: center;
	width: 100%;
`;

export const ButtonWrapper = styled.button`
	${buttonNormalize};
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
`;
